var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClasse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7875 0.765047L74.4597 0.000696896C74.4597 0.000696896 65.0754 -0.155924 59.1862 4.22676C52.518 9.18913 50.0086 15.5149 43.1902 19.482C36.3716 23.4492 29.166 24.1776 29.166 24.1776V62.4084L75.7875 0.765047Z",
    fill: "#9E0038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5145 4.99092C53.8463 9.95349 51.3369 16.279 44.5183 20.2462C37.6997 24.2134 30.4941 24.9417 30.4941 24.9417V63.1726C30.4941 63.1726 37.6997 62.4442 44.5183 58.477C51.3369 54.5099 53.8462 48.1843 60.5145 43.2217C66.4035 38.8391 75.788 38.9957 75.788 38.9957V0.764857C75.7878 0.764857 66.4035 0.608236 60.5145 4.99092Z",
    fill: "#FF0F64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5867 22.8511L23.2148 23.638V96.9398L23.2166 96.9396C23.2208 97.4907 23.554 98.0166 24.2354 98.4099C25.7492 99.2839 28.3934 99.1743 30.1412 98.1651C31.1099 97.6059 31.5979 96.8878 31.5846 96.2097L31.5867 96.2095V22.8511Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1406 24.8122C31.8886 23.8031 32.0785 22.2765 30.5647 21.4025C29.0509 20.5285 26.4067 20.6382 24.6589 21.6473C22.9109 22.6565 22.721 24.183 24.2349 25.057C25.7487 25.931 28.3927 25.8214 30.1406 24.8122Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasse);
export default __webpack_public_path__ + "static/media/classe.036f52c50468da2624da383801990f76.svg";
export { ForwardRef as ReactComponent };